<template>
    <div id="customers-box">
        <vs-row>
            <vs-col vs-w="4">
                <vs-card>
                    <div class="d-flex align-items-center">
                        <div class="mr-2">
                            <span>SMS Allowance</span>
                            <h4>{{allowance}}</h4>
                        </div>
                        <div class="ml-auto">
                            <div>
                                <i class="mdi mdi-email h1 text-primary"></i>
                            </div>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
            <vs-col vs-w="4">
                <vs-card>
                    <div class="d-flex align-items-center">
                        <div class="mr-2">
                            <span>Consumed</span>
                            <h4>{{consumed}}</h4>
                        </div>
                        <div class="ml-auto">
                            <div>
                                <i class="mdi mdi-send h1 text-danger"></i>
                            </div>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
            <vs-col vs-w="4">
                <vs-card>
                    <div class="d-flex align-items-center">
                        <div class="mr-2">
                            <span>Balance Left</span>
                            <h4>{{allowance - consumed}}</h4>
                        </div>
                        <div class="ml-auto">
                            <div>
                                <i class="mdi mdi-cart h1 text-success"></i>
                            </div>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>
        <vs-card>
            <vs-row>
            <vs-col vs-lg="3" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex align-items-center">
                <vs-input
                      :label="$t('Time.From')"
                      timezone="FR-fr"
                      :max="endDate"
                      type="date"
                      class="w-100 mb-4"
                      v-model="startDate"
                      @change="loadSmsByRange"
              />
              </vs-col>
              <vs-col vs-lg="3" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex align-items-center">
              <vs-input
                      :label="$t('Time.To')"
                      timezone="FR-fr"
                      :max="new Date().toISOString().split('T')[0]"
                      :min="startDate"
                      type="date"
                      class="w-100 mb-4"
                      v-model="endDate"
                      @change="loadSmsByRange"
              />
            </vs-col>
          </vs-row>
        </vs-card>
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
                <vs-card>
                   
            <vs-table
              :sst="true"
              @search="handleSearch"
              @selected="handleSelected"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="transactions"
            
            >


                        <div slot="header">

                        </div>
                        <template slot="thead">
                            <vs-th sort-key="contactname">{{$t('SMS.Table.Destination')}}</vs-th>
                            <vs-th sort-key="joindate">{{$t('SMS.Table.Message')}}</vs-th>
                            <vs-th sort-key="phone">{{$t('SMS.Table.SentAt')}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].destination">
                                    <div class="d-flex no-block align-items-center">
                                        {{ data[indextr].destination }}
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].message">
                                    <div class="d-flex align-items-center">
                                        {{ data[indextr].message }}
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].created_at">
                                    <div class="d-flex align-items-center">
                                        <span class="text-muted">{{data[indextr].created_at}}</span>
                                    </div>
                                </vs-td>

                            </vs-tr>
                        </template>
                    </vs-table>
                    <vs-pagination
              @change="handleChangePage"
              :total="totalPages"
              v-model="currentPage"
            ></vs-pagination>
                           </vs-card>

            </vs-col>
        </vs-row>
    </div>
</template>

<script>
    import {smsService} from '../../_services'
    import router from "../../_helpers/router";
    // moment

    export default {
        name: "Sms",
        data: () => ({
            title: "Sms",
            transactions: [],
            selected: {},
            allowance: 0,
            consumed: 0,
            totalItems: 0,
            totalPages: 0,
            currentPage: 1,
            maxItems: 0,
            startDate: '',
            endDate: '',
            searchKeyword: ""
        }),
        methods: {
            notify(title, text, type) {
                this.$vs.notify({
                    color: type,
                    title: title,
                    text: text
                });
            },
            showLoading() {
                this.$vs.loading({
                    container: '#customers-box',
                    scale: 0.6
                });
            },

            goToNextPage(){
                router.push({ path: "/kiosks?istour=on" });
            },
            hideLoading() {
                this.$vs.loading.close('#customers-box > .con-vs-loading')
            },
            handleSelected() {
                /* eslint-disable */
                console.log(this.selected.transactions);
            },

            loadSmsByRange(keyword) {
  console.log("Handle on change date picker");
  console.log(this.startDate + " " + this.endDate);
  if (this.startDate != "" && this.endDate != "") {
    this.showLoading();
    smsService.getByDateRange(this.startDate, this.endDate , this.searchKeyword )
      .then(data => {
        this.transactions = data.transactions.data;     
        this.consumed = data.transactions.total;
        this.totalItems = data.transactions.total;
            this.maxItems = data.transactions.per_page;
            this.totalPages = data.transactions.last_page;
        console.log(this.transactions);
      })
      .finally(() => {
        this.hideLoading();
      });
  }
},




   
   


    handleSearch(keyword) {
  this.searchKeyword = keyword;

  if (this.searchTimeout) {
    clearTimeout(this.searchTimeout);
  }

  if (keyword == "") {
    this.showLoading();
    smsService
          .getAll()
          .then(
            function (data) {
            this.transactions = data.transactions.data;
            this.totalItems = data.transactions.total;
            this.maxItems = data.transactions.per_page;
            this.totalPages = data.transactions.last_page;
            this.consumed = data.transactions.total;
          
        }.bind(this)
      )
      .finally(
        function () {
          this.hideLoading();
        }.bind(this)
      );
  } else {
    this.searchTimeout = setTimeout((
      
    ) => {
      this.showLoading();
      smsService
        .getAll({keyword : keyword})
        .then(
          function (data) {
            this.transactions = data.transactions.data;
            this.totalItems = data.transactions.total;
            this.maxItems = data.transactions.per_page;
            this.totalPages = data.transactions.last_page;
            this.consumed = data.transactions.total;

          }.bind(this)
        )
        .finally(
          function () {
            this.hideLoading();
          }.bind(this)
        );
    }
    
    
    , 2000); 
  }
},
        
     handleChangePage() {
  this.showLoading();
  smsService
    .getAll({ current_page: this.currentPage, keyword: this.searchKeyword , end: this.endDate , start: this.startDate })
    .then(function(data) {
      this.transactions = data.transactions.data;
    }.bind(this))
    .finally(() => {
      this.hideLoading();
    });
},



            handleSort(key, active) {
                /* eslint-disable */
                console.log({key, active});
            },
            formatDate: function (value) {
                let date = this.$moment(value).fromNow();
                return date;
            },
        },
        mounted() {
            this.showLoading();
            this.endDate=this.$moment().format('YYYY-MM-DD');
            this.startDate=this.$moment().format('YYYY-MM-DD');
            smsService
            .getAll({ current_page: this.currentPage, per_page: this.per_page })
            .then(function (data) {
                this.transactions = data.transactions.data;
                this.allowance = data.allowance;
                this.consumed = data.transactions.total;
                this.totalItems = data.transactions.total;
                this.maxItems = data.transactions.per_page;
                this.totalPages = data.transactions.last_page;
                            }.bind(this))
            .finally(() => {
                this.hideLoading();
                console.log(this.transactions)
            });
        }
    };
</script>
